import { Accordion, Container } from "react-bootstrap";
import SectionHeader from "../../components/SectionHeader";
import img from "../../images/services-17.jpg";

function EntertainmentInsurance() {

    return (
        <>

            <section className="service-page-bg">
                <SectionHeader title="Entertainment Insurance" PageLink="Entertainment Insurance" Image={img}></SectionHeader>
                <div className="service-page-main new-service-page-main">
                    <Container>
                        <div className="">
                            <h2>Entertainment Insurance</h2>
                            <p className="strong_text_p">Keep the Spotlight Bright and the Audience Smiling</p>
                            <p>
                                Entertainment is all about creating unforgettable experiences. A stand-up set that has the crowd roaring, a beauty pageant full
                                of sparkle and elegance, a theater performance that moves people to tears, or a book signing that connects authors with their
                                readers. Every show has its magic. Every show also has its risks.
                                <br />
                                That is why our <span className="strong_text">entertainment event insurance</span> exists. We protect the energy, talent,
                                and audience so that the focus stays where it should be on the performance.
                            </p>
                            <p className="strong_text_p">Why Organizers Choose Us</p>
                            <p>
                                Our coverage is designed with the unique needs of entertainment events in mind. A comedy show has very different requirements than a
                                theater production. A beauty pageant needs different protection than a book signing. We understand those differences and create policies
                                that make sense for you. With <span className="strong_text">public entertainment insurance</span> and
                                <span className="strong_text">performer liability insurance,</span> both organizers and performers can relax knowing they are backed
                                by professional protection.
                            </p>
                            <p className="strong_text_p">What We Cover </p>
                            <ul className="list_style_disc">
                                <li><span className="strong_text">Entertainment Event Insurance</span> : Gives you peace of mind for any live entertainment experience.</li>
                                <li><span className="strong_text">Comedy Show Insurance</span> : Keeps stand-up nights and comedy festivals covered.</li>
                                <li><span className="strong_text">Beauty Pageant Insurance</span> : Protects contestants, organizers, and venues at glamorous events.</li>
                                <li><span className="strong_text">Book Signing Event Insurance</span> : Covers authors, publishers, and bookstores hosting signings.</li>
                                <li><span className="strong_text">Theater Event Insurance</span> : Safeguards plays, musicals, and stage productions.</li>
                                <li><span className="strong_text">Talent Show Insurance</span> : Covers participants, judges, and audiences at competitions.</li>
                                <li><span className="strong_text">Performer Liability Insurance</span> : Protects artists from claims of injury or property damage.</li>
                                <li><span className="strong_text">Public Entertainment Insurance</span> : Makes sure large gatherings and community shows are fully protected.</li>
                            </ul>
                            <p className="strong_text_p">How It Works </p>
                            <p>Getting coverage for your entertainment event is simple:  </p>
                            <ul className="list_style_disc">
                                <li>Enter your event details</li>
                                <li>Get an instant quote</li>
                                <li>Buy your policy online</li>
                                <li>Download your Certificate of Insurance (COI) instantly</li>
                            </ul>
                            <div className="mb-5">
                                <h2 className="">FAQs</h2>
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Do smaller events like book signings really need insurance?</Accordion.Header>
                                        <Accordion.Body>
                                            Yes. Even small gatherings come with risks, and many venues require proof of book-signing event insurance before confirming a booking.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Will performers be protected under this policy?</Accordion.Header>
                                        <Accordion.Body>
                                            Yes. With performer liability insurance, artists are covered if they accidentally cause injury or property damage during the event.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>Can I insure a theater production?</Accordion.Header>
                                        <Accordion.Body>
                                            Absolutely. Our theater event insurance is designed for plays, musicals, and other stage performances.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>What about beauty pageants or talent shows?</Accordion.Header>
                                        <Accordion.Body>
                                            We offer both beauty pageant insurance and talent show insurance so that organizers, participants, and judges all have the protection they need.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>How quickly will I receive proof of insurance?</Accordion.Header>
                                        <Accordion.Body>
                                            Instantly. As soon as you purchase your policy, your Certificate of Insurance is ready to download.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                            <p className="strong_text_p">Make Your Event Unstoppable </p>
                            <p>
                                From the laughter of a comedy night to the elegance of a pageant, our <span className="strong_text">entertainment insurance</span>
                                makes sure nothing stands in the way of a great show.
                            </p>
                        </div>
                    </Container>
                </div>
            </section>
        </>
    );
}

export default EntertainmentInsurance;
